module.exports = __webpack_public_path__ + "img/T1_ty_4.5a11564e.png";